
import SelectProductQty from '../../form/onlyone-pickup/SelectOnlyOneProduct.js';
import RemarkDiv from '../../shared/RemarkDiv.js';

function PanelSelectProductQtyMulti(props) {
   const remark=()=>{
      if (props.eventName === "2026032829_TSTopening")
        return '*3月28日(11:30-15:00)場次包括星級開幕環節: 上午11:30開放排隊，場內有福袋派發。開幕慶典於下午12:30開始(星級嘉賓:古天樂先生)，試食緊隨開幕慶典完結後開始。';
    }
    const style=()=>{
      if (props.eventName === "2026032829_TSTopening")
        return { backgroundColor: 'yellow', fontWeight: 'bold', color: 'red', whiteSpace: 'pre-line' };
    }

   return (
    <div className="step">
        {
          props.isSessionEvent
          &&
          <p>步驟3：選擇場次(必填)</p>
        }
        {
          !props.isSessionEvent
          &&
          <p>步驟3：選擇指定產品(必填)</p>
        }
        <SelectProductQty item_Details={props.item_Details} setItemQty={(Item_Code, value)=>props.setItemQty(Item_Code, value)} totalAmount={props.totalAmount} isShowScanInput={props.isShowScanInput} passClearSelectedItems={props.passClearSelectedItems}></SelectProductQty>
        {props.item_Details.length > 0 && <RemarkDiv className="remark" eventName={props.eventName} remark={remark()} style={style()}></RemarkDiv>}
    </div>
   );
 }
 
export default PanelSelectProductQtyMulti;